'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'weight-scale';
var width = 448;
var height = 512;
var aliases = ["weight"];
var unicode = 'f496';
var svgPathData = 'M314.6 176c3.5-10 5.4-20.7 5.4-32 0-53-43-96-96-96s-96 43-96 96c0 11.3 1.9 22 5.4 32l71.4 0 29.2-65.7c5.4-12.1 19.6-17.6 31.7-12.2s17.6 19.6 12.2 31.7l-20.6 46.3 57.2 0zm39.7 29.4c-5.7 12.1-18.5 18.6-31.9 18.6l-196.8 0c-13.3 0-26.2-6.5-31.9-18.6-8.8-18.6-13.7-39.5-13.7-61.4 0-23 5.4-44.7 15-64L64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16l-31 0c9.6 19.3 15 41 15 64 0 22-4.9 42.8-13.7 61.4zM64 32l69.5 0C158.2 12 189.7 0 224 0s65.8 12 90.5 32L384 32c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faWeightScale = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;